import React from 'react';
import {MdReplay, MdArrowBack} from 'react-icons/md';
import {AiFillLock, AiFillUnlock} from 'react-icons/ai';
import {BsFillPencilFill, BsShareFill} from 'react-icons/bs';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {
  setMapBounds,
  unselectSingleDevice,
} from '../redux/slices/deviceSlice';
import {
  updatePlaybackCompleted,
  updatePlaybackHistory, updatePlaybackPlaying,
  updatePlaybackPopup, updatePlaybackProgress,
  updateShowingPlayback, updateVehicleInfoPopup,
} from '../redux/slices/generalSlice';
import {enableOrDisableSafeParking} from '../Actions';
import {get} from '../helpers';
import {confirmAlert} from 'react-confirm-alert';

export default function MobileSingularHeader() {
  const showingPlayback = useSelector((state) => state.general.showingPlayback);
  const deviceImei = useSelector((state) => state.device.selectedDevice);
  const allDevices = useSelector((state) => state.device.list);
  const device = allDevices.find((item) => item.imei === deviceImei);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (!device) {
    return null;
  }
  const safeParking = get(device, 'safe_parking_location', null) !== null;

  return (
      <div
          className="w-full bg-white shadow md:hidden block flex justify-between items-center">
        <div className="h-full z-10">
          <button
              className="cursor-pointer w-12 px-2 py-4"
              onClick={() => {
                if (showingPlayback) {
                  dispatch(updateShowingPlayback(false));
                  dispatch(updatePlaybackHistory({
                    path: [],
                    stops: [],
                  }));
                  dispatch(updatePlaybackPlaying(false));
                  dispatch(updatePlaybackCompleted(true));
                  dispatch(updatePlaybackProgress(0));
                } else {
                  dispatch(setMapBounds([]));
                  dispatch(unselectSingleDevice());
                }
              }}
          >
            <MdArrowBack size={24} color="#001C6F"/>
          </button>
        </div>
        {showingPlayback && (
            <div className="flex-1 w-full absolute z-0">
              <div
                  className="text-blue-950 text-base font-bold text-center">Playback
              </div>
            </div>
        )}
        {!showingPlayback && (<>
          <button
              className="cursor-pointer flex flex-1 justify-center flex-col items-center py-2"
              onClick={() => {
                dispatch(updatePlaybackPopup(true));
              }}
          >
            <span>
              <MdReplay size={18} color="#7F7F7F"/>
            </span>
            <span
                className="text-zinc-500 text-xs font-normal mt-1">Playback</span>
          </button>
          <button
              className="cursor-pointer flex flex-1 justify-center flex-col items-center py-2"
              onClick={() => {
                if (safeParking) {
                  enableOrDisableSafeParking(deviceImei, dispatch)
                      .then((response) => {
                      });
                } else {
                  confirmAlert({
                    title: 'Confirm to enable safe parking',
                    message: 'Are you sure to do enable safe parking?',
                    buttons: [
                      {
                        label: 'Yes',
                        onClick: () => {
                          enableOrDisableSafeParking(deviceImei, dispatch)
                              .then((response) => {
                              });
                        },
                      },
                      {
                        label: 'No',
                        onClick: () => {
                        },
                      },
                    ],
                  });
                }
              }}
          >
            <span>
              {safeParking ? (
                  <AiFillLock color="#0EB600" size={24}/>
              ):(
                  <AiFillUnlock color="#7F7F7F" size={24}/>
              )}
            </span>
            <span
                className={`${safeParking ? 'text-green-600 text-bold':
                    'text-zinc-500'} text-xs font-normal mt-1`}>Safe Park</span>
          </button>
          <button
              className="cursor-pointer flex flex-1 justify-center flex-col items-center py-2"
              onClick={() => {
                dispatch(updateVehicleInfoPopup(true));
              }}
          >
            <span>
              <BsFillPencilFill size={18} color="#7F7F7F"/>
            </span>
            <span className="text-zinc-500 text-xs font-normal mt-1">Edit</span>
          </button>
          <button
              className="cursor-pointer flex flex-1 justify-center flex-col items-center py-2"
              onClick={() => {
                navigate(`/share/vehicle/${deviceImei}`);
              }}
          >
            <span>
              <BsShareFill size={18} color="#7F7F7F"/>
            </span>
            <span
                className="text-zinc-500 text-xs font-normal mt-1">Share</span>
          </button>
          {/*<button*/}
          {/*    className="cursor-pointer"*/}
          {/*>*/}
          {/*  <MdOutlineMoreVert size={24} color="#7F7F7F"/>*/}
          {/*</button>*/}
        </>)}
      </div>
  );
}
